import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-baseline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_time_picker = _resolveComponent("time-picker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "blue-grey lighten-5 text-primary" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.tMilkTitle), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_form, { ref: "post_milk_form" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "py-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_time_picker, {
                color: "primary",
                "base-color": "primary",
                modelValue: _ctx.recordedAt,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recordedAt) = $event)),
                label: _ctx.tMilkTime,
                "prepend-icon": "mdi-clock-time-four-outline",
                rules: [_ctx.rules.required],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "label", "rules"]),
              _createVNode(_component_v_select, {
                color: "primary",
                "base-color": "primary",
                modelValue: _ctx.milkCategory,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.milkCategory) = $event)),
                items: _ctx.categories,
                "item-title": "title",
                "item-value": "value",
                rules: [_ctx.rules.required],
                label: _ctx.tMilkType,
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "items", "rules", "label"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_select, {
                  color: "primary",
                  "base-color": "primary",
                  modelValue: _ctx.amountId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.amountId) = $event)),
                  items: _ctx.choices,
                  "item-title": "title",
                  "item-value": "id",
                  label: _ctx.tMilkAmount,
                  variant: "outlined",
                  density: "compact"
                }, null, 8, ["modelValue", "items", "label"]),
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "ml-1 body-1" }, "cc", -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.close,
                color: "error",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tCancel), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.clickPost,
                loading: _ctx.btnLoading,
                color: "primary",
                variant: "flat"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tSubmit), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}